/* VIMA — thème Shopify : panier latéral, sélection des variantes, sélecteur « Ton iPhone », aperçu de personnalisation. */
(function () {
  'use strict';
  var V = window.VIMA || {};
  var R = V.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[<&>"]/g, function (c) { return { '<': '&lt;', '&': '&amp;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- Prix ---------- */
  function formatMoney(cents) {
    var fmt = V.moneyFormat || '{{amount_with_comma_separator}} €';
    var n = (cents || 0) / 100;
    function d(num, dec, th, sep) {
      var p = num.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(sep);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return d(n, 2, ',', '.');
        case 'amount_no_decimals': return d(n, 0, ',', '.');
        case 'amount_with_comma_separator': return d(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return d(n, 0, '.', ',');
        case 'amount_with_space_separator': return d(n, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return d(n, 2, "'", '.');
        default: return d(n, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- Modèles d'iPhone ---------- */
  var MODELS = ['iPhone 12', 'iPhone 12 Pro', 'iPhone 12 Pro Max', 'iPhone 13', 'iPhone 13 Pro', 'iPhone 14', 'iPhone 14 Plus', 'iPhone 14 Pro', 'iPhone 14 Pro Max', 'iPhone 15', 'iPhone 15 Pro', 'iPhone 15 Pro Max', 'iPhone 16', 'iPhone 16 Plus', 'iPhone 17', 'iPhone 17 Air', 'iPhone 17 Pro', 'iPhone 17 Pro Max'];
  /* « Iphone 14plus », « iPone 15 » ou « iphone 15 pro » deviennent tous la même clé. */
  function modelKey(s) { return String(s || '').toLowerCase().replace(/^\s*i\s*p?h?one/, '').replace(/[^a-z0-9]/g, ''); }
  var KEY_TO_LABEL = {};
  MODELS.forEach(function (m) { KEY_TO_LABEL[modelKey(m)] = m; });
  function modelLabel(s) { return KEY_TO_LABEL[modelKey(s)] || s; }
  function modelRank(s) { var i = MODELS.indexOf(modelLabel(s)); return i < 0 ? 999 : i; }

  var currentModel = store.get('vima-model', 'iPhone 15');
  if (MODELS.indexOf(currentModel) < 0) currentModel = 'iPhone 15';

  function initModelSelects() {
    $$('[data-model-select]').forEach(function (sel) {
      sel.innerHTML = MODELS.map(function (m) { return '<option>' + m + '</option>'; }).join('');
      sel.value = currentModel;
      sel.addEventListener('change', function () { setModel(sel.value); });
    });
  }
  function setModel(m) {
    currentModel = m;
    store.set('vima-model', m);
    $$('[data-model-select]').forEach(function (s) { s.value = m; });
    updateCards();
    renderModelGrid();
  }

  /* ---------- Cartes produit : disponibilité pour le modèle choisi ---------- */
  function updateCards(root) {
    var key = modelKey(currentModel);
    $$('.card[data-models]', root).forEach(function (card) {
      var all = card.getAttribute('data-models').split('|').map(modelKey);
      var ok = card.getAttribute('data-models-ok').split('|').map(modelKey);
      var stock = $('[data-stock]', card);
      var state = ok.indexOf(key) >= 0 ? 'ok' : all.indexOf(key) >= 0 ? 'out' : 'none';
      if (stock) {
        stock.hidden = false;
        stock.className = 'stock' + (state === 'ok' ? '' : ' no');
        stock.textContent = state === 'ok' ? (card.hasAttribute('data-preorder') ? 'En précommande pour ' : 'En stock pour ') + currentModel : state === 'out' ? 'Épuisé pour ' + currentModel : 'Non disponible pour ' + currentModel;
      }
      var quickData = card.getAttribute('data-quick');
      var btn = $('[data-quick-add]', card), link = $('[data-quick-link]', card);
      if (quickData && btn) {
        var id = null;
        quickData.split('|').forEach(function (pair) {
          var i = pair.lastIndexOf('=');
          if (i > 0 && modelKey(pair.slice(0, i)) === key) id = pair.slice(i + 1);
        });
        btn.hidden = !id;
        if (link) link.hidden = !!id;
        if (id) {
          btn.setAttribute('data-variant', id);
          $('.q-full', btn).textContent = 'Ajout rapide · ' + currentModel;
          btn.setAttribute('aria-label', 'Ajouter au panier pour ' + currentModel);
        }
      }
    });
  }

  /* ---------- Panier ---------- */
  var drawer = $('[data-cart-drawer]'), scrim = $('[data-cart-scrim]');
  var lastFocus = null;
  function openCart() {
    if (!drawer) { location.href = R.cart; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false; scrim.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var c = $('[data-cart-close]', drawer); if (c) c.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.hidden = true; scrim.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  var toastTimer;
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 2600);
  }

  function getCart() { return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function addToCart(items) {
    return fetch(R.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function changeLine(key, qty) {
    return fetch(R.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count === 0) el.setAttribute('data-zero', ''); else el.removeAttribute('data-zero');
    });
    $$('[data-cart-open]').forEach(function (el) { el.setAttribute('aria-label', 'Ouvrir le panier (' + cart.item_count + ')'); });
    if (!drawer) return;
    $('[data-cart-title]', drawer).textContent = cart.item_count ? 'Panier (' + cart.item_count + ')' : 'Panier';

    var prefix = V.caseHandlePrefix || 'coque-';
    var goal = V.freeShippingCount || 2;
    var cases = cart.items.reduce(function (a, i) { return a + (String(i.handle).indexOf(prefix) === 0 ? i.quantity : 0); }, 0);
    var left = Math.max(goal - cases, 0);
    $('[data-ship-msg]', drawer).innerHTML = left === 0 ? '<b>La livraison est offerte.</b>' :
      cases === 0 ? 'Livraison offerte dès <b>' + goal + ' coques</b> achetées.' :
      'Plus que <b>' + left + ' coque' + (left > 1 ? 's' : '') + '</b> pour profiter de la livraison offerte.';
    $('[data-ship-bar]', drawer).style.width = Math.min(cases / goal, 1) * 100 + '%';

    var lines = $('[data-cart-lines]', drawer);
    if (!cart.items.length) {
      lines.innerHTML = '<div class="empty-cart"><p>Ton panier est vide.</p><a class="btn" href="' + R.root + 'collections/all">Découvrir les coques</a></div>';
    } else {
      lines.innerHTML = cart.items.map(function (i) {
        var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
        var sep = img.indexOf('?') >= 0 ? '&' : '?';
        var variant = i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '';
        variant = variant.split(' / ').map(modelLabel).join(' · ');
        var pre = i.properties && i.properties['Précommande'];
        if (pre) variant = (variant ? variant + ' · ' : '') + 'Précommande, ' + pre.charAt(0).toLowerCase() + pre.slice(1);
        return '<div class="line" data-key="' + esc(i.key) + '">' +
          '<a href="' + esc(i.url) + '">' + (img ? '<img src="' + esc(img + sep + 'width=200') + '" alt="' + esc(i.product_title) + '" loading="lazy">' : '') + '</a>' +
          '<div><a class="nm" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' + (variant ? '<div class="vr">' + esc(variant) + '</div>' : '') +
          '<div class="qty"><button type="button" data-line-qty="-1" aria-label="Diminuer">−</button><span>' + i.quantity + '</span><button type="button" data-line-qty="1" aria-label="Augmenter">+</button></div></div>' +
          '<div class="right"><div class="pr">' + formatMoney(i.final_line_price) + '</div><button class="rm" type="button" data-line-remove>Retirer</button></div></div>';
      }).join('');
      var tpl = $('[data-upsell-template]');
      if (tpl) {
        var handle = tpl.content.firstElementChild && tpl.content.firstElementChild.getAttribute('data-product-handle');
        var inCart = cart.items.some(function (i) { return i.handle === handle; });
        if (!inCart) lines.appendChild(tpl.content.cloneNode(true));
      }
    }
    $('[data-cart-total]', drawer).textContent = formatMoney(cart.total_price);
    $('[data-cart-foot]', drawer).hidden = !cart.items.length;
  }
  function refreshCart() { return getCart().then(renderCart).catch(function () {}); }
  /* Utilisé par la page « Personnalise ta coque ». */
  window.vimaCart = { refresh: refreshCart, open: openCart, toast: toast };

  /* Article du panier ; en précommande, la date d'expédition suit la ligne jusqu'à la commande. */
  function preorderItem(id, qty, note) {
    var item = { id: Number(id), quantity: qty };
    if (note) item.properties = { 'Précommande': note };
    return item;
  }

  function add(items, opts) {
    opts = opts || {};
    return addToCart(items).then(function () { return getCart(); }).then(function (cart) {
      renderCart(cart);
      if (opts.open) openCart(); else toast(opts.message || 'Ajouté au panier');
    }).catch(function (err) {
      toast((err && (err.description || err.message)) || 'Impossible d\'ajouter ce produit pour le moment.');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-cart-open]');
    if (opener && drawer) { e.preventDefault(); refreshCart(); openCart(); return; }
    if (t.closest('[data-cart-close]') || t.closest('[data-cart-scrim]')) { closeCart(); return; }

    var qb = t.closest('[data-quick-add]');
    if (qb) {
      e.preventDefault();
      var id = qb.getAttribute('data-variant');
      var card = qb.closest('.card'), note = card && card.getAttribute('data-preorder');
      if (id) add([preorderItem(id, 1, note)], { message: (note ? 'Précommande ajoutée · ' : 'Ajouté au panier · ') + currentModel });
      return;
    }
    var up = t.closest('[data-upsell-add]');
    if (up) { add([{ id: Number(up.getAttribute('data-upsell-add')), quantity: 1 }], { message: 'Ajouté au panier' }); return; }

    var line = t.closest('.line[data-key]');
    if (line && drawer && drawer.contains(line)) {
      var key = line.getAttribute('data-key');
      var q = Number($('.qty span', line).textContent);
      var d = t.closest('[data-line-qty]');
      if (d) { changeLine(key, Math.max(0, q + Number(d.getAttribute('data-line-qty')))).then(renderCart); return; }
      if (t.closest('[data-line-remove]')) { changeLine(key, 0).then(renderCart); return; }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) closeCart(); });

  /* Formulaires d'ajout rapide (produits sans variante) */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('quick-form')) return;
    e.preventDefault();
    var id = f.querySelector('[name="id"]').value;
    add([{ id: Number(id), quantity: 1 }], { message: 'Ajouté au panier' });
  });

  /* ---------- Tri des collections ---------- */
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      location.href = u.toString();
    });
  });

  /* ---------- Fiche produit ---------- */
  function initProduct(section) {
    var json = $('[data-product-json]', section);
    var form = $('form.p-form', section);
    if (!json || !form) return;
    var variants = JSON.parse(json.textContent);
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form);
    var status = $('[data-status]', form);
    var priceEl = $('[data-price]', section), compareEl = $('[data-compare]', section);
    var fieldsets = $$('[data-option-index]', form);
    var preorder = section.getAttribute('data-preorder');

    /* Liste déroulante des modèles : libellés harmonisés (« Iphone 15 pro » → « iPhone 15 Pro ») et triés. */
    fieldsets.forEach(function (fs) {
      if (!fs.hasAttribute('data-model-option')) return;
      var select = $('select', fs);
      var opts = $$('option', select);
      opts.forEach(function (o) { o.textContent = modelLabel(o.value); o.setAttribute('data-label', modelLabel(o.value)); });
      opts.sort(function (a, b) { return modelRank(a.value) - modelRank(b.value); })
        .forEach(function (o) { select.appendChild(o); });
      var compat = $('[data-compat]', section);
      if (compat) compat.textContent = opts.map(function (o) { return modelLabel(o.value); }).join(', ') + '.';
      /* Présélectionne le modèle choisi ailleurs sur le site s'il existe. */
      var match = opts.filter(function (o) { return modelKey(o.value) === modelKey(currentModel); })[0];
      if (match && !new URL(location.href).searchParams.get('variant')) select.value = match.value;
    });

    function selected() {
      return fieldsets.map(function (fs) {
        var s = $('select', fs); if (s) return s.value;
        var c = $('input:checked', fs); return c ? c.value : null;
      });
    }
    function find(opts) {
      return variants.filter(function (v) { return opts.every(function (o, i) { return o === null || v.options[i] === o; }); })[0];
    }
    function update() {
      var opts = selected();
      var v = find(opts);
      fieldsets.forEach(function (fs, idx) {
        var isOk = function (val) {
          var test = opts.slice(); test[idx] = val;
          return variants.some(function (x) { return x.available && test.every(function (o, i) { return o === null || x.options[i] === o; }); });
        };
        var select = $('select', fs);
        if (select) {
          $$('option', select).forEach(function (o) {
            var ok = isOk(o.value);
            o.textContent = o.getAttribute('data-label') + (ok ? '' : ' — épuisé');
            o.disabled = !ok && o.value !== select.value;
          });
          return;
        }
        var lab = $('[data-option-label]', fs), c = $('input:checked', fs);
        if (lab && c) lab.textContent = c.value;
        $$('label.o', fs).forEach(function (l) { l.classList.toggle('sold', !isOk($('input', l).value)); });
      });
      var ok = !!(v && v.available);
      if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) { compareEl.hidden = !(v.compare_at_price > v.price); compareEl.textContent = formatMoney(v.compare_at_price || 0); }
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      }
      addBtn.disabled = !ok;
      addBtn.textContent = ok ? (preorder ? 'Précommander' : 'Ajouter au panier') : (v ? 'Épuisé' : 'Indisponible');
      status.className = 'status' + (ok ? '' : ' no');
      status.textContent = ok ? (preorder ? 'Précommande · ' + preorder : 'En stock') : (v ? 'Épuisée dans cette version' : 'Cette combinaison n\'existe pas');
      var dyn = $('.dyn-checkout', form); if (dyn) dyn.style.display = ok ? '' : 'none';
    }
    form.addEventListener('change', function (e) {
      if (e.target.name && e.target.name.indexOf('option-') === 0) {
        if (e.target.closest('[data-model-option]') && MODELS.indexOf(modelLabel(e.target.value)) >= 0) setModel(modelLabel(e.target.value));
        update();
      }
    });
    $$('[data-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = $('input[name="quantity"]', form);
        input.value = Math.min(10, Math.max(1, (Number(input.value) || 1) + Number(b.getAttribute('data-qty'))));
      });
    });
    form.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.name !== 'add') return;
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.classList.add('loading');
      var qty = Number($('input[name="quantity"]', form).value) || 1;
      add([preorderItem(idInput.value, qty, preorder)], { open: true }).then(function () { addBtn.classList.remove('loading'); });
    });
    update();
  }

  /* ---------- Recommandations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.children.length) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; updateCards(el); }
      }).catch(function () {});
    });
  }

  /* ---------- Signes astro : saison en cours ---------- */
  function initAstro() {
    var box = $('[data-astro]'); if (!box) return;
    var d = new Date(), k = (d.getMonth() + 1) * 100 + d.getDate();
    var best = null, bk = -1;
    $$('.sign[data-start]', box).forEach(function (s) {
      var sk = Number(s.getAttribute('data-start'));
      if (sk <= k && sk > bk) { bk = sk; best = s; }
    });
    if (!best) best = $$('.sign[data-start]', box).filter(function (s) { return s.getAttribute('data-start') === '1222'; })[0];
    if (best) {
      best.classList.add('now');
      var p = $('[data-season]', box);
      if (p) { p.textContent = 'C\'est actuellement la saison ' + best.getAttribute('data-name') + '.'; p.hidden = false; }
    }
  }

  /* ---------- En-tête : sélecteur d'iPhone, recherche, bandeau tournant ---------- */
  var lastOpener = null;
  function openSheet(name, opener) {
    var s = $('[data-sheet="' + name + '"]'); if (!s) return;
    lastOpener = opener || document.activeElement; s.hidden = false;
    var f = s.querySelector('input, button[aria-pressed="true"], button'); if (f) f.focus();
    if (name === 'search') runSearch($('[data-search-input]').value);
  }
  function closeSheets() { $$('.sheet').forEach(function (s) { s.hidden = true; }); if (lastOpener && lastOpener.focus) lastOpener.focus(); }
  function renderModelGrid() {
    var g = $('[data-model-grid]');
    if (g) g.innerHTML = MODELS.map(function (m) { return '<button type="button" data-model="' + m + '" aria-pressed="' + (m === currentModel) + '">' + m + '</button>'; }).join('');
    $$('[data-model-label]').forEach(function (el) { el.textContent = currentModel; });
  }
  function initHeader() {
    renderModelGrid();
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-sheet-open]'); if (o) { openSheet(o.getAttribute('data-sheet-open'), o); return; }
      var m = e.target.closest('[data-model]');
      if (m && m.closest('[data-model-grid]')) { setModel(m.getAttribute('data-model')); closeSheets(); toast('Modèle enregistré : ' + currentModel); return; }
      var sheet = e.target.closest('.sheet');
      if (sheet && (e.target === sheet || e.target.closest('[data-sheet-close]'))) { closeSheets(); return; }
      var qb = e.target.closest('[data-q]'); if (qb) { var inp = $('[data-search-input]'); inp.value = qb.getAttribute('data-q'); runSearch(inp.value); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && $$('.sheet').some(function (s) { return !s.hidden; })) closeSheets(); });
    var si = $('[data-search-input]'); var timer;
    if (si) si.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { runSearch(si.value); }, 180); });
    var an = $('[data-announce]');
    var setAnn = function () { document.documentElement.style.setProperty('--announce-h', (an ? an.offsetHeight : 0) + 'px'); };
    setAnn(); window.addEventListener('resize', setAnn);
    if (an && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var msgs = an.getAttribute('data-messages').split('|').filter(function (x) { return x.trim(); }), i = 0;
      if (msgs.length > 1) setInterval(function () { i = (i + 1) % msgs.length; an.innerHTML = '<span class="msg">' + esc(msgs[i]) + '</span>'; }, 4500);
    }
  }
  var searchSeq = 0;
  function runSearch(q) {
    var box = $('[data-results]'); if (!box) return;
    q = (q || '').trim();
    if (!q) { box.innerHTML = ''; return; }
    var seq = ++searchSeq;
    fetch(R.root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (seq !== searchSeq) return;
        var list = (d.resources && d.resources.results && d.resources.results.products) || [];
        box.innerHTML = '<p class="muted small" style="padding:4px 8px">' + list.length + ' résultat' + (list.length > 1 ? 's' : '') + '</p>' +
          list.map(function (p) {
            var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '<span></span>';
            return '<a class="result" href="' + esc(p.url) + '">' + img + '<span><b>' + esc(p.title) + '</b></span><span class="price">' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
          }).join('') + (list.length ? '' : '<p class="muted" style="padding:12px 8px">Aucune coque ne correspond. Essaie « bikini » ou « azul ».</p>');
      }).catch(function () {});
  }
  /* Fenêtre « Merci » : s'ouvre au retour de l'inscription, se ferme au bouton, à la touche Échap ou en cliquant à côté. */
  function openThanks(d) {
    if (!d) return;
    if (d.showModal) { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
    var close = function () { if (d.close) d.close(); else d.removeAttribute('open'); };
    var b = d.querySelector('[data-thanks-close]'); if (b) { b.onclick = close; b.focus(); }
    d.addEventListener('click', function (e) { if (e.target === d) close(); });
  }
  /* Liste d'attente : le modèle d'iPhone devient une seconde étiquette client. */
  function initWaitlist() {
    var pop = document.querySelector('[data-thanks-pop][data-open]');
    if (pop) { openThanks(pop); if (history.replaceState) history.replaceState(null, '', location.pathname + location.hash); }
    $$('.waitlist-form').forEach(function (f) {
      f.addEventListener('submit', function () {
        var tags = f.querySelector('[data-tags-base]'), sel = f.querySelector('[data-waitlist-model]');
        if (tags && sel) tags.value = tags.getAttribute('data-tags-base') + ', ' + sel.value;
      });
    });
    $$('#lancement video').forEach(function (v) {
      v.muted = true; var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) tryPlay(); }); }, { threshold: 0.25 }).observe(v); else tryPlay();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { v.removeAttribute('autoplay'); v.pause(); v.controls = true; }
    });
  }
  /* Barre d'achat collante (mobile). */
  function initStickyATC() {
    var bar = $('[data-sticky-atc]'), add = $('[data-add-button]'); if (!bar || !add || !('IntersectionObserver' in window)) return;
    var sync = function () {
      var price = $('[data-price]'); var info = bar.querySelector('[data-sticky-info]');
      var sel = $('[data-model-option] select');
      info.textContent = (price ? price.textContent : '') + (sel ? ' · ' + modelLabel(sel.value) : '');
      var b = bar.querySelector('[data-sticky-add]'); b.disabled = add.disabled; b.textContent = add.disabled ? 'Épuisé' : ($('[data-product-section][data-preorder]') ? 'Précommander' : 'Ajouter');
    };
    bar.querySelector('[data-sticky-add]').addEventListener('click', function () { add.click(); });
    document.addEventListener('change', function () { setTimeout(sync, 0); });
    new IntersectionObserver(function (en) {
      var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      bar.classList.toggle('on', show); bar.setAttribute('aria-hidden', String(!show)); if (show) sync();
    }).observe(add);
  }

  /* ---------- Démarrage ---------- */
  function start() {
    initModelSelects();
    initHeader();
    initWaitlist();
    initStickyATC();
    updateCards();
    $$('[data-product-section]').forEach(initProduct);
    initRecommendations();
    initAstro();
    refreshCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
